import { useEffect, useState } from "react";

const navLinks = [
  { label: "首页", href: "#home" },
  { label: "猎奇频道", href: "#category" },
  { label: "热门推荐", href: "#hot" },
  { label: "邪典专题", href: "#cult" },
  { label: "暗黑连载", href: "#dark" },
  { label: "阅读排行", href: "#rank" },
  { label: "关于我们", href: "#about" },
  { label: "常见问题", href: "#faq" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-950/90 backdrop-blur border-b border-background-300/50"
          : "bg-transparent"
      }`}
    >
      <nav className="flex items-center justify-between px-4 md:px-6 py-3">
        <a href="#home" className="flex items-center gap-2.5 group">
          <span className="w-9 h-9 rounded-md bg-primary-600 flex items-center justify-center text-foreground-950 text-lg group-hover:rotate-6 transition-transform">
            <i className="ri-skull-2-line"></i>
          </span>
          <span className="font-heading text-xl font-bold text-foreground-950 tracking-wide">
            歪歪漫画
          </span>
        </a>

        <div className="hidden lg:flex items-center gap-1">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="px-3 py-2 text-sm text-foreground-500 hover:text-foreground-950 transition-colors whitespace-nowrap"
            >
              {link.label}
            </a>
          ))}
        </div>

        <div className="hidden lg:flex items-center gap-2">
          <a
            href="#hot"
            className="px-4 py-2 text-sm text-foreground-900 hover:text-foreground-950 transition-colors whitespace-nowrap"
          >
            开始阅读
          </a>
          <a
            href="#category"
            className="inline-flex items-center gap-2 px-4 py-2 rounded-md bg-primary-600 hover:bg-primary-500 text-foreground-950 text-sm font-medium transition-colors whitespace-nowrap"
          >
            <i className="ri-flashlight-line text-base"></i>
            进入频道
          </a>
        </div>

        <button
          type="button"
          aria-label="打开菜单"
          onClick={() => setOpen(!open)}
          className="lg:hidden w-10 h-10 rounded-md bg-background-800 flex items-center justify-center text-foreground-200"
        >
          <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-xl`}></i>
        </button>
      </nav>

      {open && (
        <div className="lg:hidden bg-background-950/95 border-t border-background-300/50 px-4 pb-5 pt-2">
          <div className="flex flex-col">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="py-3 text-sm text-foreground-500 hover:text-foreground-950 border-b border-background-200/40"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#category"
              onClick={() => setOpen(false)}
              className="mt-4 inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-md bg-primary-600 text-foreground-950 text-sm font-medium"
            >
              <i className="ri-flashlight-line text-base"></i>
              进入猎奇频道
            </a>
          </div>
        </div>
      )}
    </header>
  );
}